import { render, staticRenderFns } from "./CompanyAdvertisingTags.vue?vue&type=template&id=6ca59d3d"
import script from "./CompanyAdvertisingTags.vue?vue&type=script&lang=js"
export * from "./CompanyAdvertisingTags.vue?vue&type=script&lang=js"
import style0 from "./CompanyAdvertisingTags.vue?vue&type=style&index=0&id=6ca59d3d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports